import styled from 'styled-components';

import { flexColumn } from '@/styles/common';

export const Wrapper = styled.div`
  ${flexColumn};
  width: 100%;
  margin-bottom: -30px;
`;
